module.exports = __webpack_public_path__ + "static/img/home_p1.ae6c06a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_p1.jpg
// module id = 501
// module chunks = 2 3